import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Loader2, ShieldCheck, KeyRound } from "lucide-react";
import PhotoUploadButton from "../PhotoUploadButton";

export function OtpVerifyDialog({
  open,
  onOpenChange,
  otpTarget,
  otpValue,
  setOtpValue,
  verifyingOtp,
  onVerify,
  recipientName = "",
  setRecipientName,
  deliveryPhoto = "",
  setDeliveryPhoto,
}) {
  const canSubmit = otpValue.length === 6 && (recipientName || "").trim() && deliveryPhoto;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md rounded-2xl" data-testid="otp-verify-dialog" aria-describedby="otp-verify-desc">
        <DialogHeader>
          <DialogTitle className="font-['Outfit'] text-xl font-semibold text-slate-900 flex items-center gap-2">
            <ShieldCheck className="h-5 w-5 text-green-600" />
            Verify Delivery OTP
          </DialogTitle>
          <p id="otp-verify-desc" className="text-sm text-slate-500">Confirm delivery with OTP, recipient name and a proof photo</p>
        </DialogHeader>
        <div className="space-y-4 mt-4">
          <div className="bg-green-50 border border-green-200 rounded-xl p-3 text-center">
            <KeyRound className="h-7 w-7 text-green-600 mx-auto mb-1" />
            <p className="text-xs text-green-600">Order: <span className="font-mono font-bold">{otpTarget}</span></p>
          </div>
          <div className="space-y-1.5">
            <Label className="text-sm font-medium text-slate-700">Delivery OTP</Label>
            <Input
              placeholder="Enter 6-digit OTP"
              value={otpValue}
              onChange={(e) => setOtpValue(e.target.value.replace(/\D/g, "").slice(0, 6))}
              className="rounded-xl border-slate-200 h-12 text-center text-xl font-mono font-bold tracking-[0.4em] focus:border-green-500"
              maxLength={6}
              data-testid="otp-input"
            />
          </div>
          <div className="space-y-1.5">
            <Label className="text-sm font-medium text-slate-700">Recipient name (required)</Label>
            <Input
              placeholder="Who received the parcel?"
              value={recipientName}
              onChange={(e) => setRecipientName && setRecipientName(e.target.value)}
              className="rounded-xl h-11"
              data-testid="recipient-name-input"
            />
          </div>
          <div className="space-y-1.5">
            <Label className="text-sm font-medium text-slate-700">Delivery proof photo (required)</Label>
            <div className="flex justify-center">
              <PhotoUploadButton
                label={deliveryPhoto ? "Photo captured ✓" : "Take / choose photo"}
                onUpload={(b64) => setDeliveryPhoto && setDeliveryPhoto(b64)}
                disabled={verifyingOtp}
                testId="delivery-proof-photo"
              />
            </div>
          </div>
          <Button
            onClick={onVerify}
            disabled={verifyingOtp || !canSubmit}
            className="w-full bg-green-600 text-white hover:bg-green-700 rounded-xl h-12 font-semibold btn-press"
            data-testid="otp-submit-btn"
          >
            {verifyingOtp ? <Loader2 className="h-5 w-5 animate-spin mr-2" /> : <ShieldCheck className="h-5 w-5 mr-2" />}
            {verifyingOtp ? "Verifying..." : "Confirm Delivery"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default OtpVerifyDialog;
